module.exports = __webpack_public_path__ + "static/media/departure-icon.5667418b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/departure-icon.svg
// module id = 919
// module chunks = 0